<template>
  <div class="document-limit-loan pt-5">
    <v-row no-gutters>
      <v-col cols="12">
        <NormalTerms />
      </v-col>

      <v-col cols="12" class="skyblue-board">
        <SpecialTerms />
      </v-col>

      <v-col cols="12" class="mt-7">
        <TermsAgrees @emitAgreedAll="(v) => (isAgreedAll = v)" />
      </v-col>

      <v-col cols="12" class="mt-7">
        <Sign @setSignature="(v) => (userSign = v)" :cameraMode="cameraMode" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NormalTerms from '@/components/documents/limit-loan/NormalTerms.vue'
import SpecialTerms from '@/components/documents/limit-loan/SpecialTerms.vue'
import TermsAgrees from '@/components/documents/limit-loan/TermsAgrees.vue'
import Sign from '@/components/documents/limit-loan/Sign.vue'

export default {
  props: {
    cameraMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NormalTerms,
    SpecialTerms,
    TermsAgrees,
    Sign,
  },
  data() {
    return {
      isAgreedAll: false,
      userSign: null,
    }
  },
  computed: {
    isValid() {
      return this.isAgreedAll === true && !!this.userSign
    },
  },
  watch: {
    isValid(v) {
      this.$emit('emitAgreed', v)
    },
    userSign(v) {
      this.$emit('emitUserSign', v)
    },
  },
}
</script>

<style lang="scss" scoped>
.document-limit-loan {
  .skyblue-board {
    padding: 25px 15px;
    background-color: #f4faff;
  }
}
</style>
